import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { insCommentDetailsFragment } from "./queries";
import { CreateComment, CreateCommentVariables } from "./types/CreateComment";
import {
  UpdateCommentVisible,
  UpdateCommentVisibleVariables
} from "./types/UpdateCommentVisible";

export const updateCommentVisible = gql`
  mutation UpdateCommentVisible($id: ID!) {
    updateCommentVisible(id: $id) {
      errors {
        field
        message
      }
    }
  }
`;

export const useUpdateCommentVisible = makeMutation<
  UpdateCommentVisible,
  UpdateCommentVisibleVariables
>(updateCommentVisible);

export const createComment = gql`
  ${insCommentDetailsFragment}
  mutation CreateComment(
    $devicesId: String
    $email: String
    $parentId: ID!
    $parentType: String!
    $text: String
  ) {
    createComment(
      devicesId: $devicesId
      email: $email
      parentId: $parentId
      parentType: $parentType
      text: $text
    ) {
      comment {
        ...InsCommentDetailsFragment
      }
      errors {
        message
        field
      }
    }
  }
`;
export const useCreateComment = makeMutation<
  CreateComment,
  CreateCommentVariables
>(createComment);
